import { render } from "./TransactionComponent.vue?vue&type=template&id=0ce48868"
import script from "./TransactionComponent.vue?vue&type=script&lang=js"
export * from "./TransactionComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__